import merge from "deepmerge";

export default function deepMerge(object1, object2) {
    return merge(object1, object2);
}
